import { createSelector } from '@reduxjs/toolkit'

import { ApplicationState } from 'redux/Stores/types'
import { sortAlphabeticalAsc } from 'utils/sortHelper'

// select current custom endpoints
export const selectCustomEndpoints = createSelector(
  [
    // Input selectors:
    (state: ApplicationState) => state.CustomEndpointStore.data
  ],
  (data) => data
)

// select entitysets
export const selectEntitySets = createSelector(
  [
    // Input selectors:
    (state: ApplicationState) => state.CustomEndpointStore.entitySets
  ],
  (sets) => [...sets].sort((a, b) => sortAlphabeticalAsc(a.name, b.name))
)

// select which source the loaded entity sets belong to
export const selectEntitySetsSourceId = createSelector(
  [
    // Input selectors:
    (state: ApplicationState) => state.CustomEndpointStore.entitySetsSourceId
  ],
  (activeSourceId) => activeSourceId
)

// select whether the endpoints are being fetched
export const selectCustomEndpointsFetching = createSelector(
  [
    // Input selectors:
    (state: ApplicationState) => state.CustomEndpointStore.fetching
  ],
  (fetching) => fetching
)
